import React from "react";
import { Link, useNavigate } from "react-router-dom";
import MobileShell from "@/components/mobile/MobileShell";
import { useAuth } from "@/contexts/AuthContext";
import {
  LayoutDashboard, Users, Briefcase, Calculator, Database, LogOut,
  ChevronRight, Monitor, BarChart3, FolderTree, Bot, Megaphone, Settings,
} from "lucide-react";

const LINKS = [
  { group: "Operativo", items: [
    { to: "/",           label: "Dashboard desktop",    icon: LayoutDashboard },
    { to: "/pipeline",   label: "Pipeline pratiche",    icon: Briefcase },
    { to: "/statistiche",label: "Statistiche",          icon: BarChart3 },
    { to: "/portafogli", label: "Portafogli",           icon: FolderTree },
  ]},
  { group: "Strumenti", items: [
    { to: "/strumenti",  label: "Calcolatori",          icon: Calculator },
    { to: "/coach",      label: "Coach AI Playbook",    icon: Bot },
    { to: "/campagne",   label: "Campagne WhatsApp",    icon: Megaphone },
    { to: "/dati",       label: "Import / Export",      icon: Database },
  ]},
  { group: "Sistema", items: [
    { to: "/impostazioni", label: "Impostazioni",       icon: Settings },
  ]},
];

export default function MobileMore() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <MobileShell title="Altro" subtitle="Best Agent">
      {/* User card */}
      <div className="flex items-center gap-3 px-4 py-4 mb-5"
        style={{ background: "linear-gradient(135deg, #0A192F 0%, #172A45 100%)", borderRadius: 14 }}>
        <div className="w-11 h-11 rounded-full flex items-center justify-center text-base font-semibold shrink-0"
          style={{ background: "rgba(183,149,91,0.2)", color: "#B7955B", border: "1.5px solid rgba(183,149,91,0.3)" }}>
          {(user?.name || user?.email || "U").slice(0, 1).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[14px] font-semibold text-white truncate">{user?.name || "Utente"}</p>
          <p className="text-[11px] truncate" style={{ color: "rgba(183,149,91,0.8)" }}>{user?.email || ""}</p>
        </div>
        <div className="text-[10px] font-bold uppercase px-2 py-1 tracking-wider"
          style={{ background: "rgba(183,149,91,0.15)", color: "#B7955B", borderRadius: 6 }}>
          {user?.role || "Agente"}
        </div>
      </div>

      {/* Versione desktop banner */}
      <button
        onClick={() => { sessionStorage.setItem("forceDesktop", "1"); nav("/"); }}
        className="w-full flex items-center gap-3 px-4 py-3.5 mb-5 active:scale-[0.98] transition-transform"
        style={{ background: "#fff", border: "1px solid #E8ECF2", borderRadius: 12 }}>
        <div className="w-8 h-8 flex items-center justify-center" style={{ background: "#F4F6FA", borderRadius: 8 }}>
          <Monitor className="w-4 h-4" style={{ color: "#64748B" }} strokeWidth={1.6} />
        </div>
        <div className="flex-1 text-left">
          <p className="text-[13px] font-semibold text-slate-700">Apri versione desktop</p>
          <p className="text-[11px] text-slate-400">Tutte le funzionalità avanzate</p>
        </div>
        <ChevronRight className="w-4 h-4 text-slate-300" strokeWidth={1.5} />
      </button>

      {/* Link groups */}
      {LINKS.map(({ group, items }) => (
        <div key={group} className="mb-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] px-1 mb-2" style={{ color: "#94A3B8" }}>
            {group}
          </p>
          <div style={{ background: "#fff", border: "1px solid #E8ECF2", borderRadius: 12, overflow: "hidden" }}>
            {items.map((item, i) => {
              const Icon = item.icon;
              return (
                <Link key={item.to} to={item.to}
                  className={`flex items-center gap-3 px-4 py-3.5 active:bg-[#F4F6FA] transition-colors ${i < items.length - 1 ? "border-b" : ""}`}
                  style={{ borderColor: "#F0F2F5" }}>
                  <div className="w-7 h-7 flex items-center justify-center shrink-0" style={{ background: "#F4F6FA", borderRadius: 7 }}>
                    <Icon className="w-3.5 h-3.5" strokeWidth={1.8} style={{ color: "#64748B" }} />
                  </div>
                  <span className="text-[13px] font-medium text-slate-700 flex-1">{item.label}</span>
                  <ChevronRight className="w-4 h-4 text-slate-300 shrink-0" strokeWidth={1.5} />
                </Link>
              );
            })}
          </div>
        </div>
      ))}

      {/* Logout */}
      <button
        onClick={handleLogout}
        data-testid="mobile-logout"
        className="w-full flex items-center justify-center gap-2 py-3.5 mt-2 mb-6 active:opacity-70 transition-opacity"
        style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 12, color: "#DC2626" }}>
        <LogOut className="w-4 h-4" strokeWidth={1.8} />
        <span className="text-[13px] font-semibold">Esci dall'account</span>
      </button>
    </MobileShell>
  );
}
